interface FeatureCardData {
  icon: string;
  title: string;
  items: string[];
}

interface FeatureCardProps {
  card: FeatureCardData;
}

export function FeatureCard({ card }: FeatureCardProps) {
  return (
    <div className="square">
      <img src={card.icon} alt={card.title} />
      <ul>
        {card.items.map((item) => (
          <li key={item}>{item}</li>
        ))}
      </ul>
      <h4 className="h4 mt-0 mb-0">{card.title}</h4>
    </div>
  );
}

export type { FeatureCardData };
